/* tslint:disable */
import { IImage } from '../reducers/images';
import { getTranslationKey } from '../utils/helpers';

export const SORT_IMAGES_OPTIONS = [
  {
    value: 'recordedAt',
    key: 'gallerySettings.sort.by.recordedAt'
  },
  {
    value: 'createdAt',
    key: 'gallerySettings.sort.by.createdAt'
  },
  {
    value: 'originalImageName',
    key: 'gallerySettings.sort.by.originalImageName'
  },
  {
    value: 'manualOrder',
    key: 'gallerySettings.sort.by.manualOrder'
  },
  {
    value: 'uploadOrder',
    key: 'gallerySettings.sort.by.uploadOrder'
  },
  {
    value: 'randomOrder',
    key: 'gallerySettings.sort.by.randomOrder'
  }
];

// Same options as the gallery, except "Gallery order" which replaces the manual
// and random options: it reuses each gallery's own persisted sortBy/sortOrder, so
// favorites appear exactly as their gallery is currently sorted.
export const SELECTION_SORT_OPTIONS = [
  {
    value: 'orderOfSelection',
    key: 'selections.sort.by.orderOfSelection'
  },
  {
    value: 'galleryOrder',
    key: 'selections.sort.by.galleryOrder'
  },
  {
    value: 'recordedAt',
    key: 'gallerySettings.sort.by.recordedAt'
  },
  {
    value: 'createdAt',
    key: 'gallerySettings.sort.by.createdAt'
  },
  {
    value: 'originalImageName',
    key: 'gallerySettings.sort.by.originalImageName'
  },
  {
    value: 'uploadOrder',
    key: 'gallerySettings.sort.by.uploadOrder'
  }
];

export const EXPORT_TYPES = [
  {
    value: 'lightroom',
    text: getTranslationKey('exportCollection.exportTypes.lightroom'),
    delimiter: ', '
  },
  {
    value: 'captureOnePhotoMech',
    delimiter: ' ',
    text: getTranslationKey('exportCollection.exportTypes.captureOnePhotoMech')
  },
  {
    value: 'finderExplorer',
    delimiter: ' OR ',
    text: getTranslationKey('exportCollection.exportTypes.finderExplorer')
  }
];

export const IMAGE_FILE_WHITE_LIST = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];

export enum ImageUploadAnalyticsEvent {
  Started = 'images-upload-started',
  Finished = 'images-upload-finished',
  Paused = 'images-upload-paused',
  Canceled = 'images-upload-canceled',
  RetryAttempt = 'images-upload-retry-attempt'
}

export const DEFAULT_IMAGE: IImage = {
  compressionStatus: '',
  gallery_id: '',
  mimeType: '',
  originalImageName: '',
  size: 0,
  status: '',
  _id: '',
  deleteAt: '',
  extension: '',
  height: 0,
  identifier: '',
  imgsFolder: '',
  sizeMb: 0,
  width: 0,
  manualOrder: 0,
  watermarkIdentifier: '',
  isTitleImage: false,
  isSmallScreenTitleImage: false,
  _collection: '',
  _user: '',
  _watermark: '',
  duplicateId: '',
  uploadingStatus: '',
  error: '',
  errorType: '',
  uploadedAt: '',
  createdAt: '',
  recordedAt: ''
};
